import styled, { css } from 'styled-components';
import { colors } from '@/globalStyles';
import store from '@/store';
import { SMARTPHONE } from '@/constants';

export const BodyWrapper = styled.div`
  width: 370px;
  max-height: 400px;
  overflow-y: auto;
  padding-bottom: 20px;
  padding-top: 20px;
  overflow-y: auto;
  justify-content: center;
  grid-template-columns: 150px 150px;
  display: grid;
  grid-gap: 20px;
  
  ${props => {
    const { core: { targetDevice } } = store.getState();

    switch (targetDevice) {
      case SMARTPHONE: {
        return css`
          width: 100%;
        `;
      }
      default: {
        return null;
      }
    }
  }}
`;

export const CodeElement = styled.div`
  height: 120px;
  border-radius: 2px;
  max-height: 400px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.25);
  background-color: ${colors.backgroundInput};
  display: grid;
  align-items: center;
  text-align: start;
  grid-template-rows: 67px 1fr;
  padding: 10px 10px 0 10px;
  border-bottom: 2px solid;
  border-bottom-color: ${props => (props.selected ? colors.primary : 'transparent')};
  cursor: pointer;

  &:hover {
    border-bottom-color: ${colors.primary};
  }
`;

export const CodeImageWrapper = styled.div`
  width: 100%;
  height: 100%;
  background-color: white;
`;

export const Label = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding: 0;
  margin: 0;
  justify-self: flex-start;
  font-family: Lato;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: ${colors.primary};
`;